var DropdownInit;

(function ($) {

	const selectors = {
		box: '[data-dropdown]',
		content: '[data-dropdown-content]'
	}


	DropdownInit = class DropdownInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new Dropdown(el);
			})
		}
	}

	class Dropdown {
		constructor(element) {
			this.$box = $(element);

			if (this.$box.length) {
				this.init();
				this.bind();
			}

		}
		init() {
			this.$content = $(selectors.content, this.$box);
			this.isOpen = this.$box.hasClass('is-open');
		}
		bind() {

			this.onClick = this.onClick.bind(this);

			this.$box.on('click', this.onClick);
		}

		onClick() {

			if (this.isOpen) {
				this.close();
			}
			else {
				this.open();
			}

		}

		open() {
			this.isOpen = true;
			this.$box.addClass('is-open');
			this.$content.stop().slideDown();
		}
		close() {
			this.isOpen = false;
			this.$box.removeClass('is-open');
			this.$content.stop().slideUp();
		}

	}

})(jQuery);


export default DropdownInit;